import { useEffect } from "react";
import { PageHero } from "@/components/PageHero";
import { ServicesGrid } from "@/components/ServicesGrid";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { BUSINESS } from "@/data/site";

export default function Services() {
  useEffect(() => { document.title = `Services — ${BUSINESS.name}`; }, []);
  return (
    <>
      <PageHero
        overline="Services"
        titleLines={["Everything you need", "to grow online."]}
        subtitle="From premium websites to AI automation, SEO and paid ads — one team, one point of accountability, faster results."
      />
      <ServicesGrid heading={false} />
      <Faq />
      <FinalCta />
    </>
  );
}
